var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0272 0C15.035 0 16.0387 0 17.1195 0.341667C18.2995 0.771167 19.2288 1.7005 19.6583 2.8805C20 3.96117 20 4.96517 20 6.97283V13.0272C20 15.035 20 16.0387 19.6583 17.1195C19.2288 18.2995 18.2995 19.2288 17.1195 19.6582C16.0387 20 15.035 20 13.0272 20H6.97283C4.965 20 3.96117 20 2.8805 19.6582C1.7005 19.2288 0.771167 18.2995 0.341667 17.1195C0 16.0387 0 15.035 0 13.0272V6.97283C0 4.96517 0 3.96117 0.341667 2.8805C0.771167 1.7005 1.7005 0.771167 2.8805 0.341667C3.96117 0 4.965 0 6.97283 0H13.0272Z",
    fill: "url(#paint0_linear_2444_4705)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4197 14.3222C16.3922 14.3296 16.3634 14.3335 16.3337 14.3335H3.66624C3.63651 14.3335 3.60768 14.3296 3.58025 14.3223L7.52939 10.3752L8.36792 11.2343C9.26868 12.1571 10.7312 12.1571 11.6321 11.2343L12.4706 10.3752L16.4197 14.3222ZM16.6667 13.9007V6.07129C16.6667 6.03135 16.6596 5.99304 16.6467 5.95753C16.627 6.00313 12.7034 10.037 12.7034 10.037L16.6554 13.9869C16.6627 13.9594 16.6667 13.9305 16.6667 13.9007ZM3.33331 13.9339V6.10451C3.33331 6.06458 3.34037 6.02629 3.3533 5.9908C3.37297 6.03638 7.29659 10.0702 7.29659 10.0702L3.34458 14.0201C3.33723 13.9926 3.33331 13.9637 3.33331 13.9339ZM16.4358 5.67301L11.3934 10.8345C10.6234 11.6234 9.37646 11.6233 8.6065 10.8345C8.6065 10.8345 5.24547 7.39407 3.56496 5.67383C3.54974 5.65825 16.4358 5.67301 16.4358 5.67301Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2444_4705",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E51EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19E6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCon);
export default __webpack_public_path__ + "static/media/email-con.388d2a49014d26d9f9c0d01cb692ab29.svg";
export { ForwardRef as ReactComponent };